export { MainWidget as default } from './MainWidget';
